import React, { FC } from 'react';
import { SettingsFormPageSkeleton } from '../settingsSkeleton';

export const ExtensionFieldPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
